var map = {
	"./Brunch.svg": 166,
	"./Burger.svg": 167,
	"./Donuts.svg": 168,
	"./Grill.svg": 169,
	"./Hot dogs.svg": 170,
	"./Kebab.svg": 171,
	"./Pancakes.svg": 172,
	"./Pizza.svg": 173,
	"./Ramen.svg": 174,
	"./Salads.svg": 175,
	"./Sandwich.svg": 176,
	"./Soups.svg": 177,
	"./Sushi.svg": 178,
	"./Sweets.svg": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 165;